module.exports = __webpack_public_path__ + "5ec451aad62c31238880671ca306d14e.mp4";